










































































































import Vue from "vue";
import storeHelper from "../../store/store-helper";
import UserSelector from "../../components/generic/UserSelector/UserSelector.vue";
import { Controllers } from "@infoland/iprova-api";
import { Manager, Member, Membership, Team } from "@/teams";
import { UserItem } from "@/components/generic/UserSelector/types";

export default Vue.extend({
    /*
    Membership: user of usergroup that belongs to the team.
    Member: all users that belong to the team directly or via a usergroup that has a membership.
    Manager: a member that is marked as manager. Has manage permissions for the team. Every team must have at least one manager.
    */
    name: "TeamMembers",
    components: { UserSelector },
    props: {
        team: Object as () => Team,
        members: Array as () => Member[]
    },
    data: () => {
        return { editingMemberships: false };
    },
    created() {},
    mounted() {},
    computed: {
        currentUserIsManager(): boolean {
            return this.managerIDs.indexOf(this.$user.user_id) > -1;
        },
        managerIDs(): string[] {
            return this.team.managers.map(m => m.user_id);
        },
        memberIDs(): string[] {
            return this.members.map(m => m.user_id);
        },
        groupMemberships(): Membership[] {
            return this.team.memberships.filter(m => m.user_group_id !== undefined);
        },
        membershipIDs(): string[] {
            return this.team.memberships.map(m => (m.user_id ? m.user_id : m.user_group_id));
        }
    },
    methods: {
        getMemberIsManager(member: Member): boolean {
            return this.managerIDs.includes(member.user_id);
        },

        getHasDirectMembership(member: Member): boolean {
            //to determine whether a membership is direct or only via groups
            return this.membershipIDs.includes(member.user_id);
        },

        getCanDeleteUserMembership(member: Member) {
            //current user must be manager, there must be more than one membership and the user must have a personal membership (not via group)
            return this.currentUserIsManager && this.team.memberships.length > 1 && this.getHasDirectMembership(member);
        },

        getCanDeleteGroupMembership(member: Member) {
            return this.currentUserIsManager && this.team.memberships.length > 1;
        },

        getDeleteMemberClass(member: Member) {
            if (member.user_id ? this.getCanDeleteUserMembership(member) : this.getCanDeleteGroupMembership(member)) return "";
            else return "invisible";
        },

        async deleteMembership(membership: Membership) {
            await storeHelper.teamsStore.deleteMembership(this.team.team_id, membership.user_id, membership.user_group_id);
            let members = await Controllers.GenericController.getAsync<Member[]>(`/teams/${this.team.team_id}/members`);
            if (!members.map(x => x.user_id).includes(this.$user.user_id)) {
                this.$router.push("/");
            }
        },

        onMembershipsChanged(newMemberships: UserItem[]) {
            this.editingMemberships = false;
            newMemberships.forEach(newMembership => {
                const user_id: string = newMembership.type == "user" ? newMembership.assigneeId : "";
                const user_group_id: string = newMembership.type == "user" ? "" : newMembership.assigneeId;
                storeHelper.teamsStore.addMembership(this.team.team_id, user_id, user_group_id);
            });
        },

        getCanDeleteManager(manager: Manager) {
            if (!this.currentUserIsManager) {
                return false;
            }

            if (manager.user_id === this.$user.user_id) {
                return false;
            }

            return this.team.managers.length > 1;
        },

        getManagerTooltipText(member: Member) {
            if (this.getMemberIsManager(member)) return this.$t("teams.managerTooltipOn");
            else return this.$t("teams.managerTooltipOff");
        },

        deleteManager(manager: Manager) {
            storeHelper.teamsStore.deleteManager(this.team.team_id, manager.user_id);
        },

        async toggleManager(member: Member) {
            if (this.currentUserIsManager) {
                //only manager can edit managers
                if (this.getMemberIsManager(member)) {
                    if (this.team.managers.length > 1) {
                        let confirmTitle: string = this.$t("teams.deleteSelfAsManagerConfirmTitle") as string;
                        let confirmMessage: string = this.$t("teams.deleteSelfAsManagerConfirmMessage") as string;
                        if (this.$user.user_id != member.user_id || (await this.$confirm(confirmTitle, confirmMessage))) {
                            //at least one manager should remain
                            //lookup manager and delete
                            storeHelper.teamsStore.deleteManager(
                                this.team.team_id,
                                this.managerIDs.find(m => m === member.user_id)
                            );
                        }
                    }
                }
                //add member as manager
                else {
                    storeHelper.teamsStore.addManager(this.team.team_id, member.user_id);
                }
            }
        }
    }
});
